import { cva, VariantProps } from 'class-variance-authority';

export const licensePlateContainerVariants = cva(
  'rounded-4 overflow-hidden flex',
  {
    variants: {
      size: {
        default: '',
        small: '',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

export const licensePlateCountryContainerVariants = cva(
  'bg-[#2B4C9C] flex flex-col items-stretch',
  {
    variants: {
      size: {
        default: 'min-w-40 md:min-w-32',
        small: 'min-w-16',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

export const licensePlateCountryVariants = cva('object-contain object-center', {
  variants: {
    size: {
      default: 'w-16 h-32',
      small: 'w-12 h-20',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export const licensePlateInputVariants = cva(
  'bg-[#ECA80A] text-center placeholder:text-grayscale600 placeholder:opacity-20 outline-none data-[disabled="true"]:text-grayscale600/50 ',
  {
    variants: {
      size: {
        default:
          'px-32 py-16 md:py-12 font-semibold text-2xl leading-6 md:text-3xl md:leading-8 min-w-[200px]',
        small: 'px-16 py-12 text-sm md:text-base leading-2 md:leading-3',
      },
    },

    defaultVariants: {
      size: 'default',
    },
  },
);

export type LicensePlateSizeVariants = VariantProps<
  typeof licensePlateCountryContainerVariants
>;
